import { inject } from '@angular/core';
import {
  patchState,
  signalStore,
  withMethods,
  withState,
} from '@ngrx/signals';
import { ProductStore } from './product.store';
import { GroupJourneyStore } from './group-journey.store';
import { InviteService } from '../service/invite-service';
import { InviteReturnTypes } from '../utils/commonTypes';
import { ApiResultTypes } from '../utils/domain-services-api-reason-codes';

type InviteState = {
  // invite:InviteData|null
  // isLoading: boolean;
  isCreatingInvite: boolean;
  // isMarkingInviteAccepted:boolean;
  isAcceptingInvite: boolean;
};

const initialState: InviteState = {
  // invite:null,
  // isLoading: false,
  isCreatingInvite: false,
  // isMarkingInviteAccepted: false,
  isAcceptingInvite: false
};

export const InviteStore = signalStore(
  { providedIn: 'root' },

  withState(initialState),
  withMethods((store, service = inject(InviteService), prodStore = inject(ProductStore), gjStore = inject(GroupJourneyStore)  ) => ({
    

    // async loadInvite(linkId:string): Promise<InviteReturnTypes>{
    //   patchState(store, { isLoading: true });
    //   try{
    //     const response = await service.getLinkFull(linkId);
    //     patchState(store, { isLoading: false, invite: response.data? response.data:null });
    //     return response.operationResult;
    //   }catch(e){
    //     patchState(store, { isLoading: false });
    //     return InviteReturnTypes.GENERIC_ERROR;
    //   }

    // },

    async acceptInvite(linkId:string): Promise<boolean>{
      patchState(store, { isAcceptingInvite: true });
      try{
        const result = await service.acceptInvite(linkId);
        patchState(store, { isAcceptingInvite: false });
        return result.result === ApiResultTypes.SUCCESS;
      }catch(e){
        patchState(store, { isAcceptingInvite: false });
        return false;
      }
    },

    async createInvite(groupId:string): Promise<{linkId:string,success:boolean,operationResult:ApiResultTypes}>{
      
      patchState(store, { isCreatingInvite: true });
      try{
        const result = await service.createInvite(groupId);
        patchState(store, { isCreatingInvite: false });
        return {
          linkId:result.linkId??'', 
          success: result.result === ApiResultTypes.SUCCESS, 
          operationResult: result.result
        };
      }catch(e){
        patchState(store, { isCreatingInvite: false });
        return {linkId:'',success:false,operationResult:ApiResultTypes.ERROR};
      }
    },
  }))
);

